import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { QuestionResponseObjectEditModalPage } from './question-response-object-edit-modal.page';

const routes: Routes = [
  {
    path: '',
    component: QuestionResponseObjectEditModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [QuestionResponseObjectEditModalPage]
})
export class QuestionResponseObjectEditModalPageModule {}
